import { render, staticRenderFns } from "./DeviceManagementSuspend.vue?vue&type=template&id=67f74ab6&scoped=true&"
import script from "./DeviceManagementSuspend.vue?vue&type=script&lang=js&"
export * from "./DeviceManagementSuspend.vue?vue&type=script&lang=js&"
import style0 from "./DeviceManagementSuspend.vue?vue&type=style&index=0&id=67f74ab6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f74ab6",
  null
  
)

export default component.exports